import fx from "../../utils/fx";
import AxiosInterceptor from "api/interceptor";

const permission = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return permission.get("/guard/permissions?" + qstr);
  },
  getMe() {
    return permission.get("/guard");
  },
  getByGroup() {
    return permission.get("/guard/groups");
  },
  getDetail(id) {
    return permission.get(`/guard/permissions/${id}`);
  },
  updateDetail(id, data) {
    return permission.put(`/guard/permissions/${id}`, data);
  },
  autoLoadPermission() {
    return permission.post(`/guard/permissions/autoload`);
  },
  getPermissionByGroup(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return permission.get("/guard/permissions/groups?" + qstr);
  }
};
